import { createSlice } from "@reduxjs/toolkit";
import requestDiscount from "@custom/rtk-apis/billing/discountNotification/requestDiscount";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const requestDiscountSlice = createSlice({
  name: "requestDiscountSlice",
  initialState,
  reducers: {
    resetDiscountSlice (state:any) {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestDiscount.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(requestDiscount.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(requestDiscount.rejected, (state, { payload }) => {
        state.loading = false;
        state.msg =  payload.msg || 'An unexpected error occurred.';
      });
  },
});

export default requestDiscountSlice.reducer;
export const { resetDiscountSlice } = requestDiscountSlice.actions;
